export default __webpack_public_path__ + "035a49eba9849cbf4c3eb46ceec4b1f6.png";